import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  style: {"enable-background":"new 0 0 429 202.8"},
  version: "1.0",
  viewBox: "0 0 429 202.8"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M1385 2016.9c-372-27-655-66-1045-146-238-48-333-72-337-84-2-6 147-10 395-10 553-1 884-27 1135-91 234-59 366-133 474-266 43-53 62-68 120-92 124-53 317-157 385-208 166-127 180-245 41-350-71-54-239-131-399-184-390-128-791-183-1464-201-266-7-277-8-160-15 200-11 355-51 384-100 19-32-5-70-64-100-81-41-235-63-697-99-84-7-153-16-153-22 0-5 16-7 38-3 20 3 168 8 327 12 286 6 419 2 1205-40 871-47 1343 7 1735 198 190 93 279 162 535 411 229 223 297 276 413 320 60 23 54 30-66 89-165 80-287 106-496 106-167 0-184 10-266 156-75 135-130 208-225 298-207 195-527 331-920 391-150 22-454 45-595 43-66 0-201-6-300-13z",
      style: {"fill":"#e21f1d"},
      transform: "matrix(.1 0 0 -.1 0 203)"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "NO-logo"}) } }